import React from 'react';
import { motion } from 'framer-motion';
import interactive from './AboutInteractive.module.css';
import usePrefersReducedMotion from './usePrefersReducedMotion';

export default function ScrollCue(){
  const reduce = usePrefersReducedMotion();
  return (
    <div className={interactive.scrollCue} aria-hidden>
      {!reduce && (
        <>
          <motion.div className={interactive.scrollDot} initial={{ scale:0 }} animate={{ scale:1 }} transition={{ duration:.6 }} />
          <motion.div className={interactive.scrollChevron} initial={{ opacity:0 }} animate={{ opacity:1 }} transition={{ delay:.4 }} />
        </>
      )}
      <span style={{ letterSpacing:.5 }}>Scroll</span>
    </div>
  );
}
